import { IBoundedContext } from '../../config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { ApiService, ConfigService } from '../../shared/services';
import { LocationQtyDetail } from '../shared/models';

@Injectable()
export class LocationEditQtyService {

  private _inventory: IBoundedContext;

  constructor(
                private _apiService: ApiService,
                private _configService: ConfigService ) {
                     this._inventory = this._configService.getContext('inventory');
                }

  updateQty(locationQtyDetail: LocationQtyDetail): Observable<boolean> {
      return this._apiService.patch(
                                        this._inventory.url,
                                        `inventory/${locationQtyDetail.locationId}/products/${locationQtyDetail.productId}`,
                                        locationQtyDetail.details
                                    )
                .map(response => response);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/location-edit-qty/location-edit-qty.service.ts